import { Link } from "react-router-dom";
import type { NewsItem } from "@/lib/media";
import { formatDate } from "@/lib/media";

interface NewsListCardProps {
  item: NewsItem;
  showCover?: boolean;
}

export default function NewsListCard({ item, showCover = true }: NewsListCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex cursor-pointer gap-4 border-b border-background-200 py-4 last:border-b-0"
    >
      {showCover ? (
        <div className="h-[96px] w-[136px] shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      ) : null}
      <div className="flex min-w-0 flex-1 flex-col justify-center">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="rounded bg-primary-100 px-1.5 py-0.5 text-[10px] font-medium text-primary-700">
            {item.category}
          </span>
          <span>{formatDate(item.date)}</span>
          <span className="hidden sm:inline">· {item.author}</span>
        </div>
        <h3 className="mt-1.5 line-clamp-2 font-heading text-[15px] font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs leading-relaxed text-foreground-500">
          {item.excerpt}
        </p>
      </div>
    </Link>
  );
}